// @flow

import * as React from 'react';

import cooolhome from 'src/assets/service_cooolhome.svg';
import cooolbox from 'src/assets/service_cooolbox.svg';
import cooolmax from 'src/assets/service_cooolmax.svg';
import cooolnet from 'src/assets/service_cooolnetgbit.svg';

const imgMap = {
    cooolhome,
    cooolbox,
    cooolmax,
    'cooolnet gbit': cooolnet,
};

const serviceNames = Object.keys(imgMap);

type Props = {
    serviceName: typeof serviceNames,
    style?: Object,
}

const ServiceLogo = ({ serviceName, style }: Props) => (
    serviceName ? <img src={imgMap[serviceName]} alt={serviceName} style={style} /> : null
);

ServiceLogo.defaultProps = {
    style: undefined,
};

export default ServiceLogo;
